<template>
  <PageContainer>
    <div class="flex flex-col flex-wrap content-center">
      <div class="px-8">
        <h2><span class="font-bold">{{ userStore.user.name }}</span>, we've created a personalised plan for you</h2>
        <p>To best achieve your goal to <span class="bg-teal-100">{{ userStore.goalYour }}</span> we <span v-if="!planStore.typeMatchesGoal">first </span>recommend this plan 😀</p>
      </div>
      <div class="bg-sky-100 rounded-lg mt-6 p-4">
        <h3 class="mb-2">Your Sleep Plan</h3>
        <div class="flex flex-row items-center gap-4 border-2 border-teal-200 rounded-lg p-2 bg-theme-teal-bg mb-2">
          <img src="@/assets/metric_consistency.png" class="h-12">
          <div class="text-left">
            <div>Goal</div>
            <div class="font-medium">To {{ planStore.type }}</div>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-2">
          <div class="border-2 border-teal-200 rounded-lg p-2 bg-theme-teal-bg">
            <div>Length</div>
            <div class="font-medium"><span class="text-2xl">{{ planStore.stageCount }}</span> weeks</div>
          </div>
          <div class="border-2 border-teal-200 rounded-lg p-2 bg-theme-teal-bg">
            <div>Bed time</div>
            <div class="font-medium"><span class="text-2xl">{{ formatTime(planStore.missionObjective?.bedTime) }}</span></div>
          </div>
        </div>
        <button @click="goToNext()">Start plan →</button>
      </div>
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'
import { usePlanStore } from '@/stores/plan'
import { time24To12 } from '@/helpers/time'

export default {
  name: 'OnboardingPlan',
  components: {
    PageContainer,
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
    }
  },
  beforeMount() {
    this.loadPlan()
  },
  watch: {
  },
  methods: {
    loadPlan() {
      this.planStore.load()
    },
    formatTime(value) {
      return !value ? '' : time24To12(value)
    },
    goToNext() {
      this.$router.push('/plan/outline')
    },
  },
  computed: {
    ...mapStores(useUserStore, usePlanStore),
  }
}
</script>